// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Hydew-moisturiser.jpg";
import thumb1 from "../assets/images/New-Products/extra/Hydew-moisturiser.png";
import thumb2 from "../assets/images/New-Products/Hydew-moisturiser.jpg";
import thumb3 from "../assets/images/New-Products/extra/Hydew-moisturiser.jpg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Hydew Face</h2>
              <p className="sub-heading text-muted">MOISTURISER FOR OILY & ACNE PRONE SKIN </p>
              <h5>Product Overview</h5>
              <p>
                Most people with oily/combination skin type skip out a moisturiser from their skin care regime after washing and toning their face.
                Hydew Oil Free Moisturiser is a light weight, non-greasy formula that works great for normal, oily or a combination of these two skin types.
                It gets absorbed easily into the skin, lending it a smooth finish. Being oil free, it not just delivers hydration, but also prevents the sebum secreting glands from overwork.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Hydew Face?</span>
                </h3>
                <p>
                  Read the label carefully before use,Store in a cool dry place away from direct sunlight
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Provides immediate hydration using exclusive 3D Hydromanil.</li>
                    <li>Zinc PCA helps reduce acne and control sebum production.</li>
                    <li>Offers deep hydration and reduces transepidermal water loss (TEWL).</li>
                    <li>Features a unique white, oil-free cream base.</li>
                    <li>Gives a sheer matte finish.</li>
                    <li>Lightweight with long-lasting hydration.</li>
                    <li>Helps restore and strengthen overall skin health.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Clean the skin thoroughly with a gentle face wash before application.</li>
                      <li>Take 1–2 pumps of the moisturizer.</li>
                      <li>Apply liberally and evenly over the face.</li>
                      <li>Use daily for best results.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>
                        <strong>Hydromanil:</strong> A 3D hydrocolloid matrix. Galactomannan in Hydromanil prevents transepidermal water loss (TEWL), ensures immediate hydration, provides a homogeneous appearance, and allows sequential release of oligosaccharides.
                      </li>
                      <li>
                        <strong>Silk Amino Acids:</strong> Act as a Natural Moisturizing Factor (NMF) for the skin. Low molecular weight amino acids such as glycine, alanine, and serine provide better penetration and moisturization. These are hydrolyzed from pure silk fibers.
                      </li>
                      <li>
                        <strong>Niacinamide:</strong> Helps control acne, decreases sebum secretion, and reduces inflammation associated with acne.
                      </li>
                      <li>
                        <strong>Lecigel Base:</strong> A gelling agent with emulsifying properties that creates a unique oil-free cream base. It gives the moisturizer a non-greasy feel and increases skin hydration by minimizing TEWL.
                      </li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
